(function () {
  'use strict';
  var config = window.rsLaunchConfig || {};
  var dates = {
    booster: Date.parse(config.boosterStart),
    trialCountdown: Date.parse('2026-10-15T00:00:00-07:00'),
    trialEnd: Date.parse('2026-10-19T00:00:00-07:00'),
    holidayStart: Date.parse('2026-11-17T00:00:00-08:00'),
    holidayEnd: Date.parse('2026-12-04T00:00:00-08:00')
  };
  var stages = {
    booster: '2026-10-13T09:00:00-07:00',
    trial: '2026-10-15T09:00:00-07:00',
    regular: '2026-10-19T09:00:00-07:00',
    holiday: '2026-11-17T09:00:00-08:00',
    final: '2026-12-03T09:00:00-08:00',
    ended: '2026-12-04T09:00:00-08:00'
  };
  var params = new URLSearchParams(location.search);
  var stage = config.allowPreview && stages[params.get('rs_stage')] ? params.get('rs_stage') : '';
  var started = Date.now();
  function now() { return stage ? Date.parse(stages[stage]) + Date.now() - started : Date.now(); }
  function state(at) {
    return {
      holiday: (config.holidayReady || !!stage) && at >= dates.holidayStart && at < dates.holidayEnd,
      trialCountdown: at >= dates.trialCountdown && at < dates.trialEnd,
      trialEnded: at >= dates.trialEnd,
      booster: !!config.boosterEnabled && at >= dates.booster && (!config.boosterEnd || at < Date.parse(config.boosterEnd))
    };
  }
  function route() {
    if (config.designMode) return false;
    if (!/\/products\/redsalt-elite(?:-memberships)?\/?$/.test(location.pathname)) return false;
    var s = state(now()), url = new URL(location.href), view = url.searchParams.get('view');
    if (view && view !== 'holiday2026' && view !== 'elite') return false;
    var desired = s.holiday ? 'holiday2026' : null;
    if (view === 'holiday2026' && !config.holidayReady && !stage && config.allowPreview) return false;
    if (desired === view || (!desired && !view)) return false;
    if (desired) url.searchParams.set('view', desired); else url.searchParams.delete('view');
    location.replace(url.toString());
    return true;
  }
  window.rsLaunch = { now: now, state: state, dates: dates, preview: stage, route: route };
  route();
  function fillClock(node, end) {
    var seconds = Math.max(0, Math.floor((end - now()) / 1000));
    var values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
    node.querySelectorAll('[data-rs-unit]').forEach(function(el, i) { el.textContent = String(values[i]).padStart(2, '0'); });
  }
  function render() {
    var s = state(now());
    document.querySelectorAll('[data-rs-campaign-banner]').forEach(function(el) {
      var holiday = el.dataset.rsCampaignBanner === 'holiday';
      el.hidden = holiday ? !s.holiday : !s.trialCountdown;
      fillClock(el, holiday ? dates.holidayEnd : dates.trialEnd);
    });
    document.querySelectorAll('[data-rs-booster-disclosure]').forEach(function(el) { el.hidden = !s.booster; });
    document.querySelectorAll('[data-rs-regular-copy]').forEach(function(el) { el.hidden = s.holiday; });
    document.querySelectorAll('[data-rs-holiday-copy]').forEach(function(el) { el.hidden = !s.holiday; });
    if (stage && !document.querySelector('[data-rs-date-preview]')) {
      var notice = document.createElement('div');
      notice.dataset.rsDatePreview = '';
      notice.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#171717;color:white;text-align:center;padding:8px;font:12px Arial';
      notice.textContent = 'DATE PREVIEW: ' + stage.toUpperCase() + ' · Checkout disabled · Live discount dates unchanged';
      document.body.appendChild(notice);
    }
  }
  window.addEventListener('submit', function(event) {
    var holidayPage = document.querySelector('.rs-holiday-banner');
    if ((stage || (holidayPage && (!config.holidayReady || !state(Date.now()).holiday))) && event.target.matches('form[action*="/cart/add"], #redsalt-preset-bundle-form')) {
      event.preventDefault(); event.stopImmediatePropagation();
      alert(stage ? 'This is a date preview. Checkout is disabled.' : 'Holiday checkout is on hold until the first-delivery price and free gifts are verified together.');
    }
  }, true);
  function start() {
    render();
    if (params.get('rs_purchase') === 'onetime') {
      var trialOption = document.querySelector('[data-rs-toggle="onetime"]');
      if (trialOption && trialOption.getAttribute('aria-expanded') !== 'true') trialOption.click();
    }
    if (stage) {
      document.addEventListener('click', function(event) {
        var anchor = event.target.closest('a[href]');
        if (!anchor) return;
        var target = new URL(anchor.href, location.href);
        if (target.origin !== location.origin || !(/^\/products\/redsalt-elite/.test(target.pathname) || target.pathname === '/')) return;
        target.searchParams.set('rs_stage', stage);
        if (params.has('preview_theme_id')) target.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
        anchor.href = target.toString();
      }, true);
    }
    var last = state(now());
    setInterval(function() {
      var current = state(now());
      if (last.holiday !== current.holiday) { if (route()) return; }
      if (last.trialEnded !== current.trialEnded && window.rsRefreshOtpPrice) window.rsRefreshOtpPrice();
      last = current; render();
    }, 1000);
    document.addEventListener('visibilitychange', function() { if (!document.hidden) { route(); render(); if(window.rsRefreshOtpPrice) window.rsRefreshOtpPrice(); } });
    window.addEventListener('pageshow', function() { route(); render(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* October 15 purchase UI: use the existing selector; never submit a cart. */
(function () {
  'use strict';
  if (window.rsPurchaseUiInstalled) return;
  window.rsPurchaseUiInstalled = true;
  var trialId = 'redsalt-onetime-trial';
  var scrollVersion = 0;
  var elitePath = /\/products\/redsalt-elite(?:-memberships)?\/?$/;

  function prepare() {
    var form = document.getElementById('redsalt-preset-bundle-form');
    if (!form) return null;
    var trial = form.querySelector('[data-rs-choice="onetime"]');
    if (trial) trial.id = trialId;
    return trial;
  }

  function headerOffset() {
    var bottom = 0;
    document.querySelectorAll('header, [role="banner"], [data-rs-date-preview]').forEach(function(node) {
      for (var el = node; el && el !== document.body; el = el.parentElement) {
        var style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') continue;
        var rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height || rect.height > window.innerHeight * 0.55) continue;
        var top = parseFloat(style.top);
        if (!isFinite(top)) continue;
        if (top >= 0 && top < window.innerHeight * 0.35) bottom = Math.max(bottom, top + rect.height);
      }
    });
    return bottom + 12;
  }

  function openTrial() {
    var trial = prepare();
    if (!trial) return false;
    var toggle = trial.querySelector('[data-rs-toggle="onetime"]');
    if (!toggle) return false;
    if (toggle.getAttribute('aria-expanded') !== 'true' || !trial.classList.contains('is-active')) toggle.click();
    var version = ++scrollVersion;
    function align() {
      if (version !== scrollVersion || !trial.isConnected || toggle.getAttribute('aria-expanded') !== 'true') return;
      var offset = headerOffset();
      trial.style.scrollMarginTop = offset + 'px';
      window.scrollTo({ top: Math.max(0, window.scrollY + trial.getBoundingClientRect().top - offset), left: 0, behavior: 'instant' });
    }
    /* The existing toggle preserves scroll in its first animation frame. Wait for it. */
    requestAnimationFrame(function() { requestAnimationFrame(function() { align(); setTimeout(align, 240); }); });
    if (document.readyState !== 'complete') window.addEventListener('load', align, { once: true });
    return true;
  }

  function trialTarget(anchor) {
    if (!anchor) return null;
    var target;
    try { target = new URL(anchor.href, location.href); } catch (error) { return null; }
    if (target.origin !== location.origin || !elitePath.test(target.pathname)) return null;
    if (!anchor.hasAttribute('data-rs-trial-link') && target.searchParams.get('rs_purchase') !== 'onetime') return null;
    var current = new URLSearchParams(location.search);
    target.searchParams.set('rs_purchase', 'onetime');
    target.hash = trialId;
    if ((window.rsLaunchConfig || {}).allowPreview) {
      ['preview_theme_id', 'rs_stage'].forEach(function(key) { if (current.has(key)) target.searchParams.set(key, current.get(key)); });
    }
    anchor.href = target.toString();
    return target;
  }

  function init() {
    prepare();
    document.querySelectorAll('a[data-rs-trial-link], a[href*="rs_purchase=onetime"]').forEach(trialTarget);
  }
  document.addEventListener('click', function(event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (!trialTarget(anchor)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (anchor.target && anchor.target !== '_self') || anchor.hasAttribute('download')) return;
    if (!elitePath.test(location.pathname) || !prepare()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var current = new URL(location.href);
    current.searchParams.set('rs_purchase', 'onetime'); current.hash = trialId;
    try { history.replaceState(history.state, '', current.toString()); } catch (error) { /* Selection still works without history access. */ }
    openTrial();
  }, true);
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function(name) {
    window.addEventListener(name, function() { scrollVersion++; }, { passive: true });
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  function startUi() {
    init();
    if (elitePath.test(location.pathname) && (new URLSearchParams(location.search).get('rs_purchase') === 'onetime' || location.hash === '#' + trialId)) openTrial();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startUi); else startUi();
})();
